/**
 * Which tariffs module a user sees — the same old/new migration Posição de caixa runs, in one place.
 *
 * The two modules are now served by ONE menu entry: the rebuilt one is what opens, and a user who needs the old
 * screens opts out from the settings menu. That is deliberately asymmetric — a default nobody has to discover, plus
 * an escape hatch for whoever still depends on the old layout, instead of two entries where the same client's numbers
 * are computed twice and nobody knows which one is "the" module.
 */

/**
 * localStorage key persisting the user's choice: absent → NEW, so the rebuilt module is what everyone lands on;
 * an explicit 'LEGACY' sticks across navigation and reloads until they switch back.
 */
export const TARIFFS_VERSION_KEY = 'tariffsVersion';

export type TariffsVersion = 'NEW' | 'LEGACY';

/**
 * Legacy sunset. Until this date the old module is one click away; from the day AFTER it the new one is mandatory and
 * the "voltar" affordance disappears. Change the two in lockstep — there is no server flag, this is the single source.
 */
// Shown to users (pt-BR). Keep in sync with TARIFFS_LEGACY_MANDATORY_FROM.
export const TARIFFS_LEGACY_SUNSET_DISPLAY = '30/09/2026';
// The instant the new module becomes mandatory: 00:00 local of the day AFTER the sunset date.
// Month is 0-indexed, so 9 = October → 2026-10-01T00:00 local (the old module stays through 30/09).
export const TARIFFS_LEGACY_MANDATORY_FROM = new Date(2026, 9, 1, 0, 0, 0, 0);

/** True once the old module has been retired and the new one is mandatory. */
export const isTariffsLegacyRetired = (): boolean => Date.now() >= TARIFFS_LEGACY_MANDATORY_FROM.getTime();
